import { render, staticRenderFns } from "./DisclaimerPanel.vue?vue&type=template&id=3acaed24&"
import script from "./DisclaimerPanel.vue?vue&type=script&lang=ts&"
export * from "./DisclaimerPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports